// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__8XTiL","col":"styles_col__3EDxd"};